export const getToken = () => localStorage.getItem('token') || false;

export const setToken = value => {
  localStorage.setItem('token', value);
};

export const clearToken = () => {
  localStorage.clear('token');
};
